export enum SupportTypes {
  CREATE = '@supportDoc/CREATE',
  CREATE_SUCCESS = '@supportDoc/CREATE_SUCCESS',
  CREATE_FAILED = '@supportDoc/CREATE_FAILED',
  DELETE = '@supportDoc/DELETE',
  DELETE_SUCCESS = '@supportDoc/DELETE_SUCCESS',
  DELETE_FAILED = '@supportDoc/DELETE_FAILED',
  GET = '@supportDoc/GET',
  GET_SUCCESS = '@supportDoc/GET_SUCCESS',
  GET_FAILED = '@supportDoc/GET_FAILED',
  GETALL = '@supportDoc/GETALL',
  GETALL_SUCCESS = '@supportDoc/GETALL_SUCCESS',
  GETALL_FAILED = '@supportDoc/GETALL_FAILED',
  GETALL_BY_CODE = '@supportDoc/GETALL_BY_CODE',
  GETALL_BY_CODE_SUCCESS = '@supportDoc/GETALL_BY_CODE_SUCCESS',
  GETALL_BY_CODE_FAILED = '@supportDoc/GETALL_BY_CODE_FAILED',
  GET_BY_DOWNLOAD = '@suuportDoc/GET_BY_DOWNLOAD',
  GET_BY_DOWNLOAD_SUCESS = '@suuportDoc/GET_BY_DOWNLOAD_SUCESS',
  GET_BY_DOWNLOAD_FAILED = '@suuportDoc/GET_BY_DOWNLOAD_FAILED',
}
